// src/data/TermsContent.js

import React from 'react';

const TermsContent = () => {
  return (
    <div className="legal-content">
      <h2>📜 Terms & Conditions — Naoko (AI Agent)</h2>

      <h3>1. Introduction</h3>
      <p>
        These Terms and Conditions ("Terms") govern your use of the Naoko platform (naoko.live). By accessing or using our services, you agree to be bound by these Terms. If you do not agree, please do not use our platform.
      </p>

      <h3>2. Services Offered</h3>
      <p>Naoko is a virtual assistant that helps users apply for:</p>
      <ul>
        <li>Government schemes and social welfare programs <strong>(free of cost)</strong></li>
        <li>Scholarships</li>
        <li>PAN cards <strong>(₹150 processing fee)</strong></li>
        <li>Certificates such as income, domicile, tribe, etc. <strong>(₹30 per application)</strong></li>
      </ul>
      <p>
        We provide assistance through chatbot interaction, document collection, and backend processing for application submission.
      </p>

      <h3>3. User Eligibility</h3>
      <ul>
        <li>You must be at least 18 years old or have consent from a guardian to use this service.</li>
        <li>Users must provide accurate and complete information to ensure successful processing of applications.</li>
        <li>Users are responsible for maintaining the confidentiality of their login credentials.</li>
      </ul>

      <h3>4. Use of Uploaded Documents</h3>
      <ul>
        <li>Documents are used only to fill out application forms on behalf of the user.</li>
        <li>All uploaded files are deleted from our servers after the application is submitted and confirmed.</li>
        <li>In future versions of the app, users may be allowed to store documents locally for ease of access.</li>
      </ul>

      <h3>5. Payment Terms</h3>
      <ul>
        <li>Services such as social welfare applications are provided free of cost.</li>
        <li>Other services like PAN card and certificate applications require a nominal processing fee.</li>
        <li>Payments are securely processed through <strong>PayU</strong>.</li>
        <li>No refunds are issued once the application process begins unless explicitly stated.</li>
      </ul>

      <h3>6. Service Limitations</h3>
      <ul>
        <li>
          Naoko uses automated tools and human assistance (approx. 10%) to fill and submit applications. However, final approval is at the discretion of respective government bodies.
        </li>
        <li>
          We are not responsible for rejections, delays, or errors caused by incorrect user data or external portals.
        </li>
        <li>Naoko does not guarantee approval of applications.</li>
      </ul>

      <h3>7. Account Suspension or Termination</h3>
      <p>We reserve the right to suspend or terminate accounts that:</p>
      <ul>
        <li>Provide false documents or information</li>
        <li>Abuse or misuse the chatbot</li>
        <li>Attempt to hack, spam, or interfere with services</li>
      </ul>

      <h3>8. User Conduct</h3>
      <ul>
        <li>Users agree to interact with the chatbot respectfully.</li>
        <li>The platform should not be used for any unlawful or fraudulent activities.</li>
        <li>Users must not upload offensive, harmful, or misleading content.</li>
      </ul>

      <h3>9. Intellectual Property</h3>
      <p>
        All content, branding, and features on Naoko are the property of the platform and may not be copied or reproduced without permission.
      </p>

      <h3>10. Liability Disclaimer</h3>
      <ul>
        <li>Naoko acts as a facilitator and does not represent any government body.</li>
        <li>While we aim for accuracy, we do not take liability for application failures or technical glitches.</li>
        <li>The user assumes full responsibility for the use of Naoko's services.</li>
      </ul>

      <h3>11. Modifications to Terms</h3>
      <p>
        We may modify these Terms from time to time. Updated versions will be posted on the website. Continued use of the platform constitutes acceptance of the new terms.
      </p>

      <h3>12. Contact Information</h3>
      <p>If you have questions about these Terms, feel free to contact us:</p>
      <ul>
        <li>📧 Email: <a href="mailto:support@naoko.live">support@naoko.live</a></li>
        <li>🌐 Website: <a href="https://naoko.live" target="_blank" rel="noopener noreferrer">https://naoko.live</a></li>
      </ul>

      <p style={{ marginTop: '1rem' }}>
        Effective Date: April 11, 2025
      </p>
    </div>
  );
};

export default TermsContent;
